import { Button, Checkbox, Form, Input, Link, Message, Tabs } from '@arco-design/web-react'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { loginApi } from '@/services/login'
import agentUser from '@/stores/agentUser';
import AccountSelector from '@/components/AccountSelector/AccountSelector';
import { AccountManager, AccountType } from '@/utils/accountManager';
function UserLogin() {
    const [form] = Form.useForm()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [checkdata, setcheckdata] = useState(false);
    const [selectedAccount, setSelectedAccount] = useState('')
    const [rememberedPassword, setRememberedPassword] = useState('');

    const validatePhoneNumber = (value, callback) => {
        const regex = /^1(3|4|5|6|7|8|9)\d{9}$/;
        if (!value) {
            callback(<div>请输入正确的用户名</div>);
        } else {
            callback();
        }
    };
    function validatePassword(value, callback) {
        if (!value) {
            callback(<div>密码不能为空</div>);
        } else if (!/^.{6,}$/.test(value)) {
            callback(
                <div>请输入6-12个字符，支持数字、大小写字母和符号至少包含一种</div>
            );
        } else {
            callback();
        }
    }
    const handleAccountChange = (phoneNumber: string, password?: string) => {
        setSelectedAccount(phoneNumber)
        if (password) {
            form.setFieldValue("password", password)
            setRememberedPassword(password)
        } else {
            form.setFieldValue("password", "")
            setRememberedPassword("")
        }
        form.setFieldValue("phone_number", phoneNumber)
    }

    useEffect(() => {
        // 清除密码框和状态
        form.setFieldValue("password", "")
        setRememberedPassword("")
        setSelectedAccount("")
        setcheckdata(false)

        // 迁移旧账号数据
        AccountManager.migrateOldAccounts()
    }, []);
    return (
        <Form form={form} wrapperCol={{ span: 24 }} style={{ width: 386, paddingBottom: '20px' }} onSubmit={() => {
            form.validate().then(formData => {
                setLoading(true)
                loginApi(formData).then(res => {
                    localStorage.setItem('Token', res.data.token)
                    sessionStorage.setItem("Token", res.data.token)
                    agentUser.setIsThisAgent(false)
                    window.localStorage.setItem("isClient", "true")
                    // 只有勾选记住密码时才保存账号和密码
                    if (checkdata) {
                        AccountManager.saveAccount({
                            phone_number: formData.phone_number,
                            password: formData.password,
                            remember_password: checkdata
                        }, AccountType.USER)
                    }
                    
                    navigate('/matrix')
                }).catch(e => {
                    // Message.error(e)
                }).finally(() => {
                    setLoading(false)
                })
            })
        }}>
            <Form.Item
                field="phone_number"
                rules={[
                    { validator: validatePhoneNumber, validateTrigger: "onBlur" },
                ]}>
                <AccountSelector
                    value={selectedAccount}
                    onChange={handleAccountChange}
                    placeholder="请输入或选择账号"
                    style={{ width: '100%' }}
                    accountType={AccountType.USER}
                />
            </Form.Item>
            <Form.Item field="password"
                rules={[{ validator: validatePassword, validateTrigger: ["onBlur"] }]}
            >
                <Input.Password className="login-input" placeholder='请输入密码'></Input.Password>
            </Form.Item>
            <div id="login-actions">
                <Checkbox
                    checked={checkdata}
                    onChange={() => {
                        setcheckdata(!checkdata);
                    }}
                >
                    记住密码
                </Checkbox>

            </div>
            <Form.Item>
                <Button loading={loading} className="login-button" type="primary" size="large" onClick={() => form.submit()}>登录</Button>
            </Form.Item>
        </Form>
    )
}

export default UserLogin